import React from 'react';

class HasAltin extends React.Component {

   state = {
      alis_ekleme: 0,
      satis_ekleme: 0
   }

   componentWillMount() {
      const {data,type} = this.props;
      if (data && data.has_altin) {
         this.setState({...data.has_altin})
      }
   }

   componentWillReceiveProps(nextProps){
      if(this.props.data !== nextProps.data){
         if (nextProps.data && nextProps.data.has_altin) {
            this.setState({...nextProps.data.has_altin})
         }
      }
   }

   changeValue = (e,key) => {
      this.setState({[key]:e.target.value},this.onChange)
   }

   onChange = () => {
      this.props.onChange({...this.state})
   }

   render() {
      return (
         <React.Fragment>
            <div className="box">
               <div>
                  <span className="title">Has Altın</span>
                  <div className="work_area">
                     <table style={{width: '100%'}}>
                        <tbody>
                        <tr>
                           <td>
                              <div className="left_col">
                                 <table>
                                    <tbody>
                                    <tr>
                                       <td>Alış fiyatına ({this.props.hasAltin.alis}) </td>
                                       <td><input type="number" style={{margin: '0 10px'}} value={this.state.alis_ekleme} onChange={(e)=>{this.changeValue(e,'alis_ekleme')}} placeholder="miktar"/></td>
                                       <td>ekle</td>
                                    </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </td>
                           <td>
                              <div className="right_col">
                                 <table>
                                    <tbody>
                                    <tr>
                                       <td>Satış fiyatına ({this.props.hasAltin.satis}) </td>
                                       <td><input type="number" style={{margin: '0 10px'}} value={this.state.satis_ekleme} onChange={(e)=>{this.changeValue(e,'satis_ekleme')}} placeholder="miktar"/></td>
                                       <td>ekle</td>
                                    </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </td>
                        </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
            <br/>
         </React.Fragment>
      );
   }
}

export default HasAltin


// WEBPACK FOOTER //
// ./src/component/HasAltin.js